var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('LazyHydrate',{key:_vm.containerProps.id,attrs:{"when-visible":{ rootMargin: '200px' }}},[(_vm.shouldRender)?_c('CustomContainer',_vm._b({},'CustomContainer',_vm.containerProps,false),[_vm._t("default")],2):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }